/**
 * Convert Syte locale to standard one
 * @param locale - example: en_US
 * @returns en
 */
export const convertSyteLocaleToStandardLocale = (locale: string): string =>
  locale.replace(/_/g, '-');
